module.exports = __webpack_public_path__ + "img/logo.4acc82ae.png";